import * as actionTypes from "./actionTypes";


export const loadStateDistrictList = (data) => {
  return {
    type: actionTypes.LOAD_STATE_DISTRICT_LIST
  };
};

export const loadStateDistrictListSuccess = data => {
  return {
    type: actionTypes.LOAD_STATE_DISTRICT_LIST_SUCCESS,

    data
  };
};


export const loadLanguages = (data) => {
  return {
    type: actionTypes.LOAD_LANGUAGUES,
    data
  };
};

export const loadLanguagesSuccess = data => {

  return {
    type: actionTypes.LOAD_LANGUAGUES_SUCCESS,
    data
  };
};


export const loadLanguagesFail = () => {
  return {
    type: actionTypes.LOAD_LANGUAGUES_FAIL
  };
};



export const loadVerificationCode = data => {
  return {
    type: actionTypes.LOAD_VERIFICATION_CODE,
    data
  };
};

export const loadVerificationCodeSuccess = data => {

  return {
    type: actionTypes.LOAD_VERIFICATION_CODE_SUCCESS,
    data
  };
};


export const loadVerificationCodeFail = () => {
  return {
    type: actionTypes.LOAD_VERIFICATION_CODE_FAIL
  };
};




export const loadOrderType = (data) => {
  return {
    type: actionTypes.LOAD_ORDER_TYPE,
    data
  };
};

export const loadOrderTypeSuccess = data => {

  return {
    type: actionTypes.LOAD_ORDER_TYPE_SUCCESS,
    data
  };
};


export const loadOrderTypeFail = () => {
  return {
    type: actionTypes.LOAD_ORDER_TYPE_FAIL
  };
};


export const loadRecyclingRanking = data => {
  return {
    type: actionTypes.LOAD_RECYCLING_RANKING,
    data
  };
};

export const loadRecyclingRankingSuccess = data => {
  return {
    type: actionTypes.LOAD_RECYCLING_RANKING_SUCCESS,
    data
  };
};

export const loadRecyclingRankingFail = () => {
  return {
    type: actionTypes.LOAD_RECYCLING_RANKING_FAIL
  };
};



export const setOrderType = (id, data) => {
  return {
    type: actionTypes.SET_ORDER_TYPE,
    data,
    id
  };
};

export const setOrderTypeSuccess = () => {

  return {
    type: actionTypes.SET_ORDER_TYPE_SUCCESS,
  };
};


export const setOrderTypeFail = () => {
  return {
    type: actionTypes.SET_ORDER_TYPE_FAIL
  };
};


export const removeOrderType = (id, data) => {
  return {
    type: actionTypes.REMOVE_ORDER_TYPE,
    id,
    data
  };
};

export const removeOrderTypeSuccess = () => {

  return {
    type: actionTypes.REMOVE_ORDER_TYPE_SUCCESS,
  };
};


export const removeOrderTypeFail = () => {
  return {
    type: actionTypes.REMOVE_ORDER_TYPE_FAIL
  };
};


export const setDistance = (id, data) => {
  return {
    type: actionTypes.SET_DISTANCE,
    data,
    id
  };
};

export const setDistanceSuccess = () => {

  return {
    type: actionTypes.SET_DISTANCE_SUCCESS,
  };
};


export const setDistanceFail = () => {
  return {
    type: actionTypes.SET_DISTANCE_FAIL
  };
};


export const removeDistance = (id, data) => {
  return {
    type: actionTypes.REMOVE_DISTANCE,
    id,
    data
  };
};

export const removeDistanceSuccess = () => {

  return {
    type: actionTypes.REMOVE_DISTANCE_SUCCESS,
  };
};


export const removeDistanceFail = () => {
  return {
    type: actionTypes.REMOVE_DISTANCE_FAIL
  };
};


export const loadDriverTaskPrice = (data) => {
  return {
    type: actionTypes.LOAD_DRIVER_TASK_PRICE,
    data
  };
};

export const loadDriverTaskPriceSuccess = data => {
  return {
    type: actionTypes.LOAD_DRIVER_TASK_PRICE_SUCCESS,
    data
  };
};

export const loadDriverTaskPriceFail = () => {
  return {
    type: actionTypes.LOAD_DRIVER_TASK_PRICE_FAIL
  };
};


export const setDriverTaskPrice = (data) => {
  return {
    type: actionTypes.SET_DRIVER_TASK_PRICE,
    data
  };
};

export const setDriverTaskPriceSuccess = () => {
  return {
    type: actionTypes.SET_DRIVER_TASK_PRICE_SUCCESS,
  };
};

export const setDriverTaskPriceFail = () => {
  return {
    type: actionTypes.SET_DRIVER_TASK_PRICE_FAIL
  };
};


export const removeDriverTaskPrice = (id, data) => {
  return {
    type: actionTypes.REMOVE_DRIVER_TASK_PRICE,
    id,
    data
  };
};

export const removeDriverTaskPriceSuccess = () => {
  return {
    type: actionTypes.REMOVE_DRIVER_TASK_PRICE_SUCCESS,
  };
};

export const removeDriverTaskPriceFail = () => {
  return {
    type: actionTypes.REMOVE_DRIVER_TASK_PRICE_FAIL
  };
};


export const loadGroupDevBonusList = (data) => {
  return {
    type: actionTypes.LOAD_GROUP_DEV_BONUS_LIST,
    data
  };
};

export const loadGroupDevBonusListSuccess = data => {
  return {
    type: actionTypes.LOAD_GROUP_DEV_BONUS_LIST_SUCCESS,
    data
  };
};

export const loadGroupDevBonusListFail = () => {
  return {
    type: actionTypes.LOAD_GROUP_DEV_BONUS_LIST_FAIL
  };
};

export const loadGroupBonusAverage = (data) => {
  return {
    type: actionTypes.LOAD_GROUP_BONUS_AVERAGE,
    data
  };
};

export const loadGroupBonusAverageSuccess = data => {
  return {
    type: actionTypes.LOAD_GROUP_BONUS_AVERAGE_SUCCESS,
    data
  };
};

export const loadGroupBonusAverageFail = () => {
  return {
    type: actionTypes.LOAD_GROUP_BONUS_AVERAGE_FAIL
  };
};


export const setGroupDevBonus = (data) => {
  return {
    type: actionTypes.SET_GROUP_DEV_BONUS,
    data
  };
};

export const setGroupDevBonusSuccess = () => {
  return {
    type: actionTypes.SET_GROUP_DEV_BONUS_SUCCESS,
  };
};

export const setGroupDevBonusFail = () => {
  return {
    type: actionTypes.SET_GROUP_DEV_BONUS_FAIL
  };
};


export const updateGroupDevBonus = (id, data) => {
  return {
    type: actionTypes.UPDATE_GROUP_DEV_BONUS,
    data,
    id
  };
};

export const updateGroupDevBonusSuccess = () => {
  return {
    type: actionTypes.UPDATE_GROUP_DEV_BONUS_SUCCESS,
  };
};

export const updateGroupDevBonusFail = () => {
  return {
    type: actionTypes.UPDATE_GROUP_DEV_BONUS_FAIL
  };
};


export const removeGroupDevBonus = (id, data) => {
  return {
    type: actionTypes.REMOVE_GROUP_DEV_BONUS,
    id,
    data
  };
};

export const removeGroupDevBonusSuccess = () => {
  return {
    type: actionTypes.REMOVE_GROUP_DEV_BONUS_SUCCESS,
  };
};

export const removeGroupDevBonusFail = () => {
  return {
    type: actionTypes.REMOVE_GROUP_DEV_BONUS_FAIL
  };
};


export const loadLandfillCostType = (data) => {
  return {
    type: actionTypes.LOAD_LANDFILL_COST_TYPE,
    data
  };
};

export const loadLandfillCostTypeSuccess = data => {

  return {
    type: actionTypes.LOAD_LANDFILL_COST_TYPE_SUCCESS,
    data
  };
};


export const loadLandfillCostTypeFail = () => {
  return {
    type: actionTypes.LOAD_LANDFILL_COST_TYPE_FAIL
  };
};


export const loadTimeSlot = (data) => {
  return {
    type: actionTypes.LOAD_TIME_SLOT,
    data
  };
};

export const loadTimeSlotSuccess = data => {

  return {
    type: actionTypes.LOAD_TIME_SLOT_SUCCESS,
    data
  };
};


export const loadTimeSlotFail = () => {
  return {
    type: actionTypes.LOAD_TIME_SLOT_FAIL
  };
};


export const loadDistanceList = (data) => {
  return {
    type: actionTypes.LOAD_DISTANCE_LIST,
    data
  };
};

export const loadDistanceListSuccess = data => {

  return {
    type: actionTypes.LOAD_DISTANCE_LIST_SUCCESS,
    data
  };
};


export const loadDistanceListFail = () => {
  return {
    type: actionTypes.LOAD_DISTANCE_LIST_FAIL
  };
};


/**Landfill Point ***/
export const loadLandfillPoint= data => {
  return {
    type: actionTypes.LANDFILL_POINT_LOAD,
    data
  };
};

export const loadLandfillPointSuccess = data => {

  return {
    type: actionTypes.LANDFILL_POINT_LOAD_SUCCESS,
    data
  };
};


export const loadLandfillPointFail = () => {
  return {
    type: actionTypes.LANDFILL_POINT_LOAD_FAIL
  };
};


export const loadLandfillPointDetail = (id, data) => {
  return {
    type: actionTypes.LANDFILL_POINT_DETAIL,
    id,
    data
  };
};

export const loadLandfillPointDetailSuccess = data => {

  return {
    type: actionTypes.LANDFILL_POINT_DETAIL_SUCCESS,
    data
  };
};


export const loadLandfillPointDetailFail = () => {
  return {
    type: actionTypes.LANDFILL_POINT_DETAIL_FAIL
  };
};

export const addLandfillPoint = data => {
  return {
    type: actionTypes.LANDFILL_POINT_ADD,
    data
  };
};

export const addLandfillPointSuccess = () => {

  return {
    type: actionTypes.LANDFILL_POINT_ADD_SUCCESS
  };
};


export const addLandfillPointFail = () => {
  return {
    type: actionTypes.LANDFILL_POINT_ADD_FAIL
  };
};


export const editLandfillPoint = (id, data) => {
  return {
    type: actionTypes.LANDFILL_POINT_EDIT,
    id,
    data
  };
};

export const editLandfillPointSuccess = () => {

  return {
    type: actionTypes.LANDFILL_POINT_EDIT_SUCCESS
  };
};


export const editLandfillPointFail = () => {
  return {
    type: actionTypes.LANDFILL_POINT_EDIT_FAIL
  };
};


export const publishLandfillPoint = (id, data) => {
  return {
    type: actionTypes.LANDFILL_POINT_PUBLISH,
    id,
    data
  };
};

export const publishLandfillPointSuccess = () => {

  return {
    type: actionTypes.LANDFILL_POINT_PUBLISH_SUCCESS
  };
};


export const publishLandfillPointFail = () => {
  return {
    type: actionTypes.LANDFILL_POINT_PUBLISH_FAIL
  };
};


export const removeLandfillPoint = (id, data) => {
  return {
    type: actionTypes.LANDFILL_POINT_REMOVE,
    id,
    data
  };
};

export const removeLandfillPointSuccess = () => {

  return {
    type: actionTypes.LANDFILL_POINT_REMOVE_SUCCESS
  };
};


export const removeLandfillPointFail = () => {
  return {
    type: actionTypes.LANDFILL_POINT_REMOVE_FAIL
  };
};


export const editRecyclingSalesPrice = (id, data) => {
  return {
    type: actionTypes.EDIT_RECYCLING_SALES_PRICE,
    id,
    data
  };
};

export const editRecyclingSalesPriceSuccess = () => {

  return {
    type: actionTypes.EDIT_RECYCLING_SALES_PRICE_SUCCESS
  };
};


export const editRecyclingSalesPriceFail = () => {
  return {
    type: actionTypes.EDIT_RECYCLING_SALES_PRICE_FAIL
  };
};





export const setLandfillAdjustment = (id,data) => {
  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_SET,
    data,
    id
  };
};

export const setLandfillAdjustmentSuccess = () => {

  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_SET_SUCCESS
  };
};


export const setLandfillAdjustmentFail = () => {
  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_SET_FAIL
  };
};


export const removeLandfillAdjustment = (id, data) => {
  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_REMOVE,
    id,
    data
  };
};

export const removeLandfillAdjustmentSuccess = () => {

  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_REMOVE_SUCCESS
  };
};


export const removeLandfillAdjustmentFail = () => {
  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_REMOVE_FAIL
  };
};

export const loadLandfillAdjustment= data => {
  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_LOAD,
    data
  };
};

export const loadLandfillAdjustmentSuccess = data => {

  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_LOAD_SUCCESS,
    data
  };
};


export const loadLandfillAdjustmentFail = () => {
  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_LOAD_FAIL
  };
};


export const loadLandfillAdjustmentDetail = (id, data) => {
  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_DETAIL,
    id,
    data
  };
};

export const loadLandfillAdjustmentDetailSuccess = data => {

  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_DETAIL_SUCCESS,
    data
  };
};


export const loadLandfillAdjustmentDetailFail = () => {
  return {
    type: actionTypes.LANDFILL_ADJUSTMENT_DETAIL_FAIL
  };
};
/** Landfill Point END */


/**Weighing Point ***/
export const loadWeighingPoint= data => {
  return {
    type: actionTypes.WEIGHING_POINT_LOAD,
    data
  };
};

export const loadWeighingPointSuccess = data => {

  return {
    type: actionTypes.WEIGHING_POINT_LOAD_SUCCESS,
    data
  };
};


export const loadWeighingPointFail = () => {
  return {
    type: actionTypes.WEIGHING_POINT_LOAD_FAIL
  };
};



export const addWeighingPoint = data => {
  return {
    type: actionTypes.WEIGHING_POINT_ADD,
    data
  };
};

export const addWeighingPointSuccess = () => {

  return {
    type: actionTypes.WEIGHING_POINT_ADD_SUCCESS
  };
};


export const addWeighingPointFail = () => {
  return {
    type: actionTypes.WEIGHING_POINT_ADD_FAIL
  };
};


export const editWeighingPoint = (id, data) => {
  return {
    type: actionTypes.WEIGHING_POINT_EDIT,
    id,
    data
  };
};

export const editWeighingPointSuccess = () => {

  return {
    type: actionTypes.WEIGHING_POINT_EDIT_SUCCESS
  };
};


export const editWeighingPointFail = () => {
  return {
    type: actionTypes.WEIGHING_POINT_EDIT_FAIL
  };
};

export const removeWeighingPoint = (id, data) => {
  return {
    type: actionTypes.WEIGHING_POINT_REMOVE,
    id,
    data
  };
};

export const removeWeighingPointSuccess = () => {

  return {
    type: actionTypes.WEIGHING_POINT_REMOVE_SUCCESS
  };
};


export const removeWeighingPointFail = () => {
  return {
    type: actionTypes.WEIGHING_POINT_REMOVE_FAIL
  };
};
/** Weighing Point END **/



/** FEEDBACK **/
export const loadFeedbackSubjectList = (data) => {
  
  return {
    type: actionTypes.LOAD_FEEDBACK_SUBJECT_LIST,
    data
  };
};

export const loadFeedbackSubjectListSuccess = data => {
  return {
    type: actionTypes.LOAD_FEEDBACK_SUBJECT_LIST_SUCCESS,
    data
  };
};

export const loadFeedbackSubjectListFail = () => {
  return {
    type: actionTypes.LOAD_FEEDBACK_SUBJECT_LIST_FAIL
  };
};

export const loadFeedbackList = data => {
  
  return {
    type: actionTypes.LOAD_FEEDBACK_LIST,
    data
  };
};

export const loadFeedbackListSuccess = data => {
  return {
    type: actionTypes.LOAD_FEEDBACK_LIST_SUCCESS,
    data
  };
};

export const loadFeedbackListFail = () => {
  return {
    type: actionTypes.LOAD_FEEDBACK_LIST_FAIL
  };
};


export const loadFeedbackDetail = (id, data) => {
  
  return {
    type: actionTypes.LOAD_FEEDBACK_DETAIL,
    id,
    data
  };
};

export const loadFeedbackDetailSuccess = data => {
  return {
    type: actionTypes.LOAD_FEEDBACK_DETAIL_SUCCESS,
    data
  };
};

export const loadFeedbackDetailFail = () => {
  return {
    type: actionTypes.LOAD_FEEDBACK_DETAIL_FAIL
  };
};

export const getFeedbackCount = (data) => {
  
  return {
    type: actionTypes.GET_FEEDBACK_COUNT,
    data
  };
};

export const getFeedbackCountSuccess = data => {
  return {
    type: actionTypes.GET_FEEDBACK_COUNT_SUCCESS,
    data
  };
};

export const getFeedbackCountFail = () => {
  return {
    type: actionTypes.GET_FEEDBACK_COUNT_FAIL
  };
};

export const resolveFeedback = (id,data) => {
  return {
    type: actionTypes.RESOLVE_FEEDBACK,
    id,
    data
  };
};

export const resolveFeedbackSuccess = () => {
  return {
    type: actionTypes.RESOLVE_FEEDBACK_SUCCESS
  };
};

export const resolveFeedbackFail = () => {
  return {
    type: actionTypes.RESOLVE_FEEDBACK_FAIL
  };
};
/** END FEEDBACK **/

/** MERCHANT REGISTRATION **/
export const loadMerchantRegistrationList = data => {
  
  return {
    type: actionTypes.LOAD_MERCHANT_REGISTRATION_LIST,
    data
  };
};

export const loadMerchantRegistrationListSuccess = data => {
  return {
    type: actionTypes.LOAD_MERCHANT_REGISTRATION_LIST_SUCCESS,
    data
  };
};

export const loadMerchantRegistrationListFail = () => {
  return {
    type: actionTypes.LOAD_MERCHANT_REGISTRATION_LIST_FAIL
  };
};

export const loadMerchantRegistrationDetail = (id, data) => {
  
  return {
    type: actionTypes.LOAD_MERCHANT_REGISTRATION_DETAIL,
    id,
    data
  };
};

export const loadMerchantRegistrationDetailSuccess = data => {
  return {
    type: actionTypes.LOAD_MERCHANT_REGISTRATION_DETAIL_SUCCESS,
    data
  };
};

export const loadMerchantRegistrationDetailFail = () => {
  return {
    type: actionTypes.LOAD_MERCHANT_REGISTRATION_DETAIL_FAIL
  };
};



export const getMerchantRegistrationCount = (data) => {
  
  return {
    type: actionTypes.GET_MERCHANT_REGISTRATION_COUNT,
    data
  };
};

export const getMerchantRegistrationCountSuccess = data => {
  return {
    type: actionTypes.GET_MERCHANT_REGISTRATION_COUNT_SUCCESS,
    data
  };
};

export const getMerchantRegistrationCountFail = () => {
  return {
    type: actionTypes.GET_MERCHANT_REGISTRATION_COUNT_FAIL
  };
};


export const verifyMerchantRegistration = (id, data) => {
  return {
    type: actionTypes.VERIFY_MERCHANT_REGISTRATION,
    id,
    data
  };
};

export const verifyMerchantRegistrationSuccess = () => {
  return {
    type: actionTypes.VERIFY_MERCHANT_REGISTRATION_SUCCESS
  };
};

export const verifyMerchantRegistrationFail = () => {
  return {
    type: actionTypes.VERIFY_MERCHANT_REGISTRATION_FAIL
  };
};

export const rejectMerchantRegistration = (id, data) => {
  return {
    type: actionTypes.REJECT_MERCHANT_REGISTRATION,
    id,
    data
  };
};

export const rejectMerchantRegistrationSuccess = () => {
  return {
    type: actionTypes.REJECT_MERCHANT_REGISTRATION_SUCCESS
  };
};

export const rejectMerchantRegistrationFail = () => {
  return {
    type: actionTypes.REJECT_MERCHANT_REGISTRATION_FAIL
  };
};
/** END MERCHANT REGISTRATION **/

/** Promotion **/
export const loadPromotionList = data => {
  
  return {
    type: actionTypes.LOAD_PROMOTION_LIST,
    data
  };
};

export const loadPromotionListSuccess = data => {
  return {
    type: actionTypes.LOAD_PROMOTION_LIST_SUCCESS,
    data
  };
};

export const loadPromotionListFail = () => {
  return {
    type: actionTypes.LOAD_PROMOTION_LIST_FAIL
  };
};

export const addPromotion = data => {
  return {
    type: actionTypes.ADD_PROMOTION,
    data
  };
};

export const addPromotionSuccess = () => {
  return {
    type: actionTypes.ADD_PROMOTION_SUCCESS
  };
};

export const addPromotionFail = () => {
  return {
    type: actionTypes.ADD_PROMOTION_FAIL
  };
};

export const editPromotion = (id,data) => {
  return {
    type: actionTypes.EDIT_PROMOTION,
    id,
    data
  };
};

export const editPromotionSuccess = () => {
  return {
    type: actionTypes.EDIT_PROMOTION_SUCCESS
  };
};

export const editPromotionFail = () => {
  return {
    type: actionTypes.EDIT_PROMOTION_FAIL
  };
};

export const deletePromotion = (id, data) => {
  return {
    type: actionTypes.DELETE_PROMOTION,
    id,
    data
  };
};

export const deletePromotionSuccess = () => {
  return {
    type: actionTypes.DELETE_PROMOTION_SUCCESS
  };
};

export const deletePromotionFail = () => {
  return {
    type: actionTypes.DELETE_PROMOTION_FAIL
  };
};
/** END Promotion **/

/**Setings ***/
export const loadSettings = (data) => {
  return {
    type: actionTypes.SETTING_LOAD,
    data
  };
};

export const loadSettingsSuccess = data => {

  return {
    type: actionTypes.SETTING_LOAD_SUCCESS,
    data
  };
};


export const loadSettingsFail = () => {
  return {
    type: actionTypes.SETTING_LOAD_FAIL
  };
};


export const getSettingValue = (data) => {
  return {
    type: actionTypes.GET_SETTING_VALUE,
    data
  };
};

export const getSettingValueSuccess = data => {

  return {
    type: actionTypes.GET_SETTING_VALUE_SUCCESS,
    data
  };
};


export const getSettingValueFail = () => {
  return {
    type: actionTypes.GET_SETTING_VALUE_FAIL
  };
};


export const settingUpdate = data => {
  return {
    type: actionTypes.SETTING_UPDATE,
    data
  };
};

export const settingUpdateSuccess = () => {

  return {
    type: actionTypes.SETTING_UPDATE_SUCCESS
  };
};


export const settingUpdateFail = () => {
  return {
    type: actionTypes.SETTING_UPDATE_FAIL
  };
};


export const loadDrvmSettings = (data) => {
  return {
    type: actionTypes.DRVM_SETTING_LOAD,
    data
  };
};

export const loadDrvmSettingsSuccess = data => {
  return {
    type: actionTypes.DRVM_SETTING_LOAD_SUCCESS,
    data
  };
};

export const loadDrvmSettingsFail = () => {
  return {
    type: actionTypes.DRVM_SETTING_LOAD_FAIL
  };
};


export const drvmSettingUpdate = data => {
  return {
    type: actionTypes.DRVM_SETTING_UPDATE,
    data
  };
};

export const drvmSettingUpdateSuccess = () => {
  return {
    type: actionTypes.DRVM_SETTING_UPDATE_SUCCESS
  };
};

export const drvmSettingUpdateFail = () => {
  return {
    type: actionTypes.DRVM_SETTING_UPDATE_FAIL
  };
};




export const loadCarbonFootprint = (data) => {
  return {
    type: actionTypes.LOAD_CARBON_FOOTPRINT,
    data
  };
};

export const loadCarbonFootprintSuccess = data => {

  return {
    type: actionTypes.LOAD_CARBON_FOOTPRINT_SUCCESS,
    data
  };
};


export const loadCarbonFootprintFail = () => {
  return {
    type: actionTypes.LOAD_CARBON_FOOTPRINT_FAIL
  };
};



export const setCarbonFootprint = (key, data) => {
  return {
    type: actionTypes.SET_CARBON_FOOTPRINT,
    data,
    key
  };
};

export const setCarbonFootprintSuccess = () => {

  return {
    type: actionTypes.SET_CARBON_FOOTPRINT_SUCCESS,
  };
};


export const setCarbonFootprintFail = () => {
  return {
    type: actionTypes.SET_CARBON_FOOTPRINT_FAIL
  };
};


export const overallImpactLoad = (data) => {
  return {
    type: actionTypes.LOAD_OVERALL_IMPACT,
    data
  };
};

export const overallImpactLoadSuccess = data => {

  return {
    type: actionTypes.LOAD_OVERALL_IMPACT_SUCCESS,
    data
  };
};


export const overallImpactLoadFail = () => {
  return {
    type: actionTypes.LOAD_OVERALL_IMPACT_FAIL
  };
};






export const loadReferralCommission = (data) => {
  return {
    type: actionTypes.LOAD_REFERRAL_COMMISSION,
    data
  };
};

export const loadReferralCommissionSuccess = data => {

  return {
    type: actionTypes.LOAD_REFERRAL_COMMISSION_SUCCESS,
    data
  };
};


export const loadReferralCommissionFail = () => {
  return {
    type: actionTypes.LOAD_REFERRAL_COMMISSION_FAIL
  };
};



export const setReferralCommission = (data) => {
  return {
    type: actionTypes.SET_REFERRAL_COMMISSION,
    data
  };
};

export const setReferralCommissionSuccess = () => {

  return {
    type: actionTypes.SET_REFERRAL_COMMISSION_SUCCESS,
  };
};


export const setReferralCommissionFail = () => {
  return {
    type: actionTypes.SET_REFERRAL_COMMISSION_FAIL
  };
};



export const removeReferralLevel = (id, data) => {
  return {
    type: actionTypes.REMOVE_REFERRAL_LEVEL,
    data,
    id
  };
};

export const removeReferralLevelSuccess = () => {

  return {
    type: actionTypes.REMOVE_REFERRAL_LEVEL_SUCCESS,
  };
};


export const removeReferralLevelFail = () => {
  return {
    type: actionTypes.REMOVE_REFERRAL_LEVEL_FAIL
  };
};






export const loadInviteFriendSettings = (data) => {
  return {
    type: actionTypes.LOAD_INVITE_FRIEND_SETTING,
    data
  };
};

export const loadInviteFriendSettingsSuccess = data => {

  return {
    type: actionTypes.LOAD_INVITE_FRIEND_SETTING_SUCCESS,
    data
  };
};


export const loadInviteFriendSettingsFail = () => {
  return {
    type: actionTypes.LOAD_INVITE_FRIEND_SETTING_FAIL
  };
};



export const setInviteFriendSettings = (data) => {
  return {
    type: actionTypes.SET_INVITE_FRIEND_SETTING,
    data
  };
};

export const setInviteFriendSettingsSuccess = () => {

  return {
    type: actionTypes.SET_INVITE_FRIEND_SETTING_SUCCESS,
  };
};


export const setInviteFriendSettingsFail = () => {
  return {
    type: actionTypes.SET_INVITE_FRIEND_SETTING_FAIL
  };
};




export const loadDriverSubscriptionSettings = (data) => {
  return {
    type: actionTypes.LOAD_DRIVER_SUBSCRIPTION_SETTING,
    data
  };
};

export const loadDriverSubscriptionSettingsSuccess = data => {

  return {
    type: actionTypes.LOAD_DRIVER_SUBSCRIPTION_SETTING_SUCCESS,
    data
  };
};


export const loadDriverSubscriptionSettingsFail = () => {
  return {
    type: actionTypes.LOAD_DRIVER_SUBSCRIPTION_SETTING_FAIL
  };
};



export const setDriverSubscriptionSettings = (data) => {
  return {
    type: actionTypes.SET_DRIVER_SUBSCRIPTION_SETTING,
    data
  };
};

export const setDriverSubscriptionSettingsSuccess = () => {

  return {
    type: actionTypes.SET_DRIVER_SUBSCRIPTION_SETTING_SUCCESS,
  };
};


export const setDriverSubscriptionSettingsFail = () => {
  return {
    type: actionTypes.SET_DRIVER_SUBSCRIPTION_SETTING_FAIL
  };
};
/** Setings END */


export const loadTruckIssue = (data) => {
  return {
    type: actionTypes.LOAD_TRUCK_ISSUE,
    data
  };
};

export const loadTruckIssueSuccess = data => {

  return {
    type: actionTypes.LOAD_TRUCK_ISSUE_SUCCESS,
    data
  };
};


export const loadTruckIssueFail = () => {
  return {
    type: actionTypes.LOAD_TRUCK_ISSUE_FAIL
  };
};



export const setTruckIssue = (id, data) => {
  return {
    type: actionTypes.SET_TRUCK_ISSUE,
    id,
    data
  };
};

export const setTruckIssueSuccess = () => {

  return {
    type: actionTypes.SET_TRUCK_ISSUE_SUCCESS,
  };
};


export const setTruckIssueFail = () => {
  return {
    type: actionTypes.SET_TRUCK_ISSUE_FAIL
  };
};


export const removeTruckIssue = (id) => {
  return {
    type: actionTypes.REMOVE_TRUCK_ISSUE,
    id
  };
};

export const removeTruckIssueSuccess = () => {

  return {
    type: actionTypes.REMOVE_TRUCK_ISSUE_SUCCESS,
  };
};


export const removeTruckIssueFail = () => {
  return {
    type: actionTypes.REMOVE_TRUCK_ISSUE_FAIL
  };
};


/* ===== Donation ===== */
export const getCharitiesCount = (data) => {
  return {
    type: actionTypes.GET_CHARITIES_COUNT,
    data
  };
};

export const getCharitiesCountSuccess = (data) => {

  return {
    type: actionTypes.GET_CHARITIES_COUNT_SUCCESS,
    data
  };
};


export const getCharitiesCountFail = () => {
  return {
    type: actionTypes.GET_CHARITIES_COUNT_FAIL
  };
};


export const getCharitiesLoad = (data) => {
  return {
    type: actionTypes.GET_CHARITIES_LOAD,
    data
  };
};

export const getCharitiesLoadSuccess = (data) => {

  return {
    type: actionTypes.GET_CHARITIES_LOAD_SUCCESS,
    data
  };
};


export const getCharitiesLoadFail = () => {
  return {
    type: actionTypes.GET_CHARITIES_LOAD_FAIL
  };
};


export const getCharitiesLoadAll = (data) => {
  return {
    type: actionTypes.GET_CHARITIES_LOAD_ALL,
    data
  };
};

export const getCharitiesLoadAllSuccess = (data) => {

  return {
    type: actionTypes.GET_CHARITIES_LOAD_ALL_SUCCESS,
    data
  };
};


export const getCharitiesLoadAllFail = () => {
  return {
    type: actionTypes.GET_CHARITIES_LOAD_ALL_FAIL
  };
};


export const getCharitiesDetail = (id, data) => {
  return {
    type: actionTypes.GET_CHARITIES_DETAIL,
    id,
    data
  };
};

export const getCharitiesDetailSuccess = (data) => {

  return {
    type: actionTypes.GET_CHARITIES_DETAIL_SUCCESS,
    data
  };
};


export const getCharitiesDetailFail = () => {
  return {
    type: actionTypes.GET_CHARITIES_DETAIL_FAIL
  };
};


export const createCharities = (data) => {
  return {
    type: actionTypes.CREATE_CHARITIES,
    data
  };
};

export const createCharitiesSuccess = () => {

  return {
    type: actionTypes.CREATE_CHARITIES_SUCCESS,
  };
};


export const createCharitiesFail = () => {
  return {
    type: actionTypes.CREATE_CHARITIES_FAIL
  };
};


export const updateCharities = (id, data) => {
  return {
    type: actionTypes.UPDATE_CHARITIES,
    id,
    data
  };
};

export const updateCharitiesSuccess = () => {

  return {
    type: actionTypes.UPDATE_CHARITIES_SUCCESS,
  };
};


export const updateCharitiesFail = () => {
  return {
    type: actionTypes.UPDATE_CHARITIES_FAIL
  };
};


export const charitiesSequenceSet = (data) => {
  return {
    type: actionTypes.SET_CHARITIES_SEQUENCE,
    data
  };
};

export const charitiesSequenceSetSuccess = () => {

  return {
    type: actionTypes.SET_CHARITIES_SEQUENCE_SUCCESS,
  };
};


export const charitiesSequenceSetFail = () => {
  return {
    type: actionTypes.SET_CHARITIES_SEQUENCE_FAIL
  };
};


export const removeCharities = (id, data) => {
  return {
    type: actionTypes.REMOVE_CHARITIES,
    id,
    data
  };
};

export const removeCharitiesSuccess = () => {

  return {
    type: actionTypes.REMOVE_CHARITIES_SUCCESS,
  };
};


export const removeCharitiesFail = () => {
  return {
    type: actionTypes.REMOVE_CHARITIES_FAIL
  };
};


export const restoreCharities = (id, data) => {
  return {
    type: actionTypes.RESTORE_CHARITIES,
    id,
    data
  };
};

export const restoreCharitiesSuccess = () => {

  return {
    type: actionTypes.RESTORE_CHARITIES_SUCCESS,
  };
};


export const restoreCharitiesFail = () => {
  return {
    type: actionTypes.RESTORE_CHARITIES_FAIL
  };
};




export const donationRecordList = (data) => {
  return {
    type: actionTypes.GET_DONATION_RECORD,
    data
  };
};

export const donationRecordListSuccess = (data) => {

  return {
    type: actionTypes.GET_DONATION_RECORD_SUCCESS,
    data
  };
};


export const donationRecordListFail = () => {
  return {
    type: actionTypes.GET_DONATION_RECORD_FAIL
  };
};



export const donationRecordDetail = (id, data) => {
  return {
    type: actionTypes.GET_DONATION_DETAIL,
    id,
    data
  };
};

export const donationRecordDetailSuccess = (data) => {

  return {
    type: actionTypes.GET_DONATION_DETAIL_SUCCESS,
    data
  };
};


export const donationRecordDetailFail = () => {
  return {
    type: actionTypes.GET_DONATION_DETAIL_FAIL
  };
};
/* ===== Donation ===== */


/* ===== Banner ===== */
export const getBannerCount = (data) => {
  return {
    type: actionTypes.GET_BANNER_COUNT,
    data
  };
};

export const getBannerCountSuccess = (data) => {
  return {
    type: actionTypes.GET_BANNER_COUNT_SUCCESS,
    data
  };
};

export const getBannerCountFail = () => {
  return {
    type: actionTypes.GET_BANNER_COUNT_FAIL
  };
};


export const getBannerLoad = (data) => {
  return {
    type: actionTypes.GET_BANNER_LOAD,
    data
  };
};

export const getBannerLoadSuccess = (data) => {
  return {
    type: actionTypes.GET_BANNER_LOAD_SUCCESS,
    data
  };
};

export const getBannerLoadFail = () => {
  return {
    type: actionTypes.GET_BANNER_LOAD_FAIL
  };
};


export const createBanner = (data) => {
  return {
    type: actionTypes.CREATE_BANNER,
    data
  };
};

export const createBannerSuccess = () => {
  return {
    type: actionTypes.CREATE_BANNER_SUCCESS,
  };
};

export const createBannerFail = () => {
  return {
    type: actionTypes.CREATE_BANNER_FAIL
  };
};


export const updateBanner = (id, data) => {
  return {
    type: actionTypes.UPDATE_BANNER,
    id,
    data
  };
};

export const updateBannerSuccess = () => {
  return {
    type: actionTypes.UPDATE_BANNER_SUCCESS,
  };
};

export const updateBannerFail = () => {
  return {
    type: actionTypes.UPDATE_BANNER_FAIL
  };
};


export const bannerSequenceSet = (data) => {
  return {
    type: actionTypes.SET_BANNER_SEQUENCE,
    data
  };
};

export const bannerSequenceSetSuccess = () => {
  return {
    type: actionTypes.SET_BANNER_SEQUENCE_SUCCESS,
  };
};

export const bannerSequenceSetFail = () => {
  return {
    type: actionTypes.SET_BANNER_SEQUENCE_FAIL
  };
};


export const removeBanner = (id, data) => {
  return {
    type: actionTypes.REMOVE_BANNER,
    id,
    data
  };
};

export const removeBannerSuccess = () => {
  return {
    type: actionTypes.REMOVE_BANNER_SUCCESS,
  };
};

export const removeBannerFail = () => {
  return {
    type: actionTypes.REMOVE_BANNER_FAIL
  };
};


export const restoreBanner = (id, data) => {
  return {
    type: actionTypes.RESTORE_BANNER,
    id,
    data
  };
};

export const restoreBannerSuccess = () => {
  return {
    type: actionTypes.RESTORE_BANNER_SUCCESS,
  };
};

export const restoreBannerFail = () => {
  return {
    type: actionTypes.RESTORE_BANNER_FAIL
  };
};
/* ===== Banner ===== */

/* ===== OpenAI Model ===== */
export const loadOpenAIModel = (data) => {
  return {
    type: actionTypes.LOAD_OPENAI_MODEL,
    data
  };
};

export const loadOpenAIModelSuccess = (data) => {
  return {
    type: actionTypes.LOAD_OPENAI_MODEL_SUCCESS,
    data
  };
};

export const loadOpenAIModelFail = () => {
  return {
    type: actionTypes.LOAD_OPENAI_MODEL_FAIL
  };
};

export const createOpenAIModel = (data) => {
  return {
    type: actionTypes.CREATE_OPENAI_MODEL,
    data
  };
};

export const createOpenAIModelSuccess = () => {
  return {
    type: actionTypes.CREATE_OPENAI_MODEL_SUCCESS
  };
};

export const createOpenAIModelFail = () => {
  return {
    type: actionTypes.CREATE_OPENAI_MODEL_FAIL
  };
};

export const updateOpenAIModel = (id, data) => {
  return {
    type: actionTypes.UPDATE_OPENAI_MODEL,
    id,
    data
  };
};

export const updateOpenAIModelSuccess = () => {
  return {
    type: actionTypes.UPDATE_OPENAI_MODEL_SUCCESS
  };
};

export const updateOpenAIModelFail = () => {
  return {
    type: actionTypes.UPDATE_OPENAI_MODEL_FAIL
  };
};

export const removeOpenAIModel = (id, data) => {
  return {
    type: actionTypes.REMOVE_OPENAI_MODEL,
    id,
    data
  };
};

export const removeOpenAIModelSuccess = () => {
  return {
    type: actionTypes.REMOVE_OPENAI_MODEL_SUCCESS
  };
};

export const removeOpenAIModelFail = () => {
  return {
    type: actionTypes.REMOVE_OPENAI_MODEL_FAIL
  };
};
/* ===== OpenAI Model ===== */

/* ===== Alert Notification ===== */
export const loadAlertNotification = (data) => {
  return {
    type: actionTypes.LOAD_ALERT_NOTIFICATION,
    data
  };
};

export const loadAlertNotificationSuccess = (data) => {
  return {
    type: actionTypes.LOAD_ALERT_NOTIFICATION_SUCCESS,
    data
  };
};

export const loadAlertNotificationFail = () => {
  return {
    type: actionTypes.LOAD_ALERT_NOTIFICATION_FAIL
  };
};

export const updateAlertNotification = (id, data) => {
  return {
    type: actionTypes.UPDATE_ALERT_NOTIFICATION,
    id,
    data
  };
};

export const updateAlertNotificationSuccess = () => {
  return {
    type: actionTypes.UPDATE_ALERT_NOTIFICATION_SUCCESS
  };
};

export const updateAlertNotificationFail = () => {
  return {
    type: actionTypes.UPDATE_ALERT_NOTIFICATION_FAIL
  };
};
/* ===== END Alert Notification ===== */

